import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { strapiCall } from "../../../utils/api";
import { CardStyled, useStyles } from "./styles";

function PolicyContents(props) {
  const classes = useStyles();
  const [richContent, setRichContent] = useState("");

  async function fetchPolicyData() {
    const payload = {
      query: `
        query {
          malaysia {
            data {
              attributes {
                privacyPolicyEN
              }
            }
          }
        }
      `,
    };

    const response = await strapiCall(payload);
    if (response.status === 200) {
      const { data } = response?.data?.data?.malaysia || {};
      if (data) {
        const content = data.attributes?.privacyPolicyEN;
        setRichContent(content);
      }
    }
  }

  useEffect(() => {
    fetchPolicyData();
  }, []);

  return (
    <Grid>
      <CardStyled
        elevation={2}
        dangerouslySetInnerHTML={{ __html: richContent }}
      />
    </Grid>
  );
}

export default PolicyContents;
